import { Fragment } from 'react';

import { IconsEnum } from '../../../../../../../../../assets/icons/types';
import { Icon } from '../../../../../../../../../helpers/Icon';
import { Translate } from '../../../../../../../../../helpers/Translate';
import { modelViewersKeys } from '../../../../../../../../../locales/keys';
import {
  MODEL_VIEWER_ASPECT_RATIO_AUTO,
  ModelViewerAspectRatioSelection,
  modelViewerAspectRatioGroups
} from '../../../../modelViewerAspectRatioConstants';
import { DisplaySettingsMenuItem } from '../DisplaySettingsMenuItem';

interface DisplaySettingsAspectRatioPanelProps {
  aspectRatio: ModelViewerAspectRatioSelection;
  onBack: () => void;
  onSelect: (value: ModelViewerAspectRatioSelection) => void;
  showGridLines: boolean;
  onToggleGridLines: () => void;
}

function DisplaySettingsAspectRatioPanel({
  aspectRatio,
  onBack,
  onSelect,
  showGridLines,
  onToggleGridLines
}: DisplaySettingsAspectRatioPanelProps) {
  return (
    <div className="flex flex-col w-full">
      <button
        type="button"
        className="px-1 block w-full group/menu-item"
        role="menuitem"
        onClick={onBack}
      >
        <div className="px-2 py-1 dark:group-hover/menu-item:bg-gray-800 group-hover/menu-item:bg-gray-100 rounded min-h-7">
          <div className="flex items-center gap-2 text-md sm:text-sm">
            <Icon className="h-4 w-4" icon={IconsEnum.CHEVRON_LEFT} />
            <span className="mr-auto font-normal sm:font-medium block truncate leading-5 text-left">
              <Translate id={modelViewersKeys.aspectRatio} />
            </span>
          </div>
        </div>
      </button>
      <hr className="border-gray-200 dark:border-gray-600 my-1" />
      <DisplaySettingsMenuItem
        label={<Translate id={modelViewersKeys.aspectRatioAuto} />}
        selected={aspectRatio === MODEL_VIEWER_ASPECT_RATIO_AUTO}
        onClick={() => onSelect(MODEL_VIEWER_ASPECT_RATIO_AUTO)}
      />
      {modelViewerAspectRatioGroups.map((group) => (
        <Fragment key={group.i18nLabel}>
          <div className="px-3 pt-1 text-2xs text-gray-500">
            <Translate id={group.i18nLabel} />
          </div>
          <hr className="border-gray-200 dark:border-gray-600 my-1 mx-3" />
          {group.values.map((value) => (
            <DisplaySettingsMenuItem
              key={value}
              label={value}
              selected={aspectRatio === value}
              onClick={() => onSelect(value)}
            />
          ))}
        </Fragment>
      ))}
      <hr className="border-gray-200 dark:border-gray-600 my-1 mx-3" />
      <DisplaySettingsMenuItem
        label={<Translate id={modelViewersKeys.aspectRatioShowGridLines} />}
        toggle
        checked={showGridLines}
        onClick={onToggleGridLines}
      />
    </div>
  );
}

export default DisplaySettingsAspectRatioPanel;
